import React, { useState, useEffect } from 'react';
import { FormSection, getFormValues, change as formChange } from 'redux-form';
import { connect } from 'react-redux';
import _ from 'lodash';
import { LabelMapper } from 'src/jbc-front/components/FormErrors';

import { RadioField, CheckboxField, TextField } from 'src/jbc-front/components/Form';
import { getRadioOptions, yesOrNo } from 'src/reducers/selectOptions';
import { useTranslation } from 'react-i18next';
import { EMPLOYEE_FORM } from 'src/constants/FormNames';
import { beNumber, isThaiMoney } from 'src/utils/CustomValidators';

const TaxCalculationSection = props => {
  // when child or parents is disabled, corresponding properties will be changed to 0 or false
  const {
    enable,
    dispatch,
    taxOnTaxStatuses,
    taxCalculationYear,
    isYearEndConfirmed,
    residentClassificationOptions,
    nonResidentTaxOptions,
    residentClassification
  } = props;
  const { t } = useTranslation();
  const [isResident, setIsResident] = useState(true);
  const RESIDENT_VALUE = 'resident';

  const toggleNonResidentTaxSetting = e => {
    if (e.target.value === RESIDENT_VALUE) {
      setIsResident(true);
    } else {
      setIsResident(false);
    }
  };

  useEffect(
    () => {
      if (residentClassification) {
        setIsResident(residentClassification === RESIDENT_VALUE);
      }
    },
    [residentClassification]
  );

  const enableStatusHandler = () => {
    const booleanFieldsName = ['isSocialSecurityContributionAllowance', 'isProvidentFundAllowance'];

    if (enable) {
      booleanFieldsName.forEach(field => {
        dispatch(formChange(EMPLOYEE_FORM, `employeeTaxCalculationSettings.${taxCalculationYear}.${field}`, false));
      });
    }
  };

  return (
    <div>
      <FormSection name={`employeeTaxCalculationSettings.${taxCalculationYear}`}>
        <LabelMapper name="employeeTaxCalculationSettings" label={t('features.Employees.components.TaxCalculationSection.tax_deduction_setting')} />
        <CheckboxField
          name="isTaxCalculation"
          label={t('features.Employees.components.TaxCalculationSection.enable_tax_calculation')}
          normalize={value => !!value}
          onChange={() => enableStatusHandler(dispatch, enable)}
          disabled={isYearEndConfirmed}
        />

        <RadioField
          label={t('features.Employees.components.TaxCalculationSection.tax_on_tax_setting')}
          name="taxOnTaxSetting"
          options={taxOnTaxStatuses}
          disabled={!enable || isYearEndConfirmed}
        />

        <RadioField
          label={t('features.Employees.components.TaxCalculationSection.resident_classification')}
          name="residentClassification"
          options={residentClassificationOptions}
          onChange={toggleNonResidentTaxSetting}
          disabled={!enable || isYearEndConfirmed}
        />

        {!isResident && (
          <RadioField
            label={t('features.Employees.components.TaxCalculationSection.non_resident_tax_setting')}
            name="nonResidentTaxSetting"
            options={nonResidentTaxOptions}
            disabled={!enable || isYearEndConfirmed}
          />
        )}

        <TextField
          label={t('features.Employees.components.TaxCalculationSection.dependant_number')}
          name="dependantNumber"
          validate={beNumber}
          disabled={!enable || isYearEndConfirmed}
        />

        {/* @TODO: Hide Provident Fund for Vietnam */}
        {/* https://donuts-vn.atlassian.net/browse/JBC-25 */}
        {/*
        <RadioField
          label={t('features.Employees.components.TaxCalculationSection.provident_fund_allowance')}
          name="isProvidentFundAllowance"
          options={yesOrNo}
          disabled={!enable || isYearEndConfirmed}
        />
        */}

        <TextField
          label={t('features.Employees.components.TaxCalculationSection.charity_amount')}
          name="charityAmount"
          validate={isThaiMoney}
          yen
          disabled={!enable || isYearEndConfirmed}
        />

        <TextField
          label={t('features.Employees.components.TaxCalculationSection.general_donation_amount')}
          name="generalDonationAmount"
          validate={isThaiMoney}
          yen
          disabled={!enable || isYearEndConfirmed}
          note={<p>{t('features.Employees.components.TaxCalculationSection.other_deduction_note')}</p>}
        />

        <TextField
          label={t('features.Employees.components.TaxCalculationSection.abroad_income_tax_amount')}
          name="abroadIncomeTaxAmount"
          validate={isThaiMoney}
          yen
          disabled={!enable || isYearEndConfirmed}
        />
      </FormSection>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
  taxScheduleClassifications: getRadioOptions(state, 'taxScheduleClassifications'),
  taxOnTaxStatuses: getRadioOptions(state, 'taxOnTaxStatuses'),
  enable: _.get(getFormValues(EMPLOYEE_FORM)(state).employeeTaxCalculationSettings, `${ownProps.taxCalculationYear}.isTaxCalculation`, false),
  marriageStatus: _.get(getFormValues(EMPLOYEE_FORM)(state).employeeTaxCalculationSettings, `${ownProps.taxCalculationYear}.isParentsAllowance`, false),
  residentClassification: _.get(
    getFormValues(EMPLOYEE_FORM)(state).employeeTaxCalculationSettings,
    `${ownProps.taxCalculationYear}.residentClassification`,
    'resident'
  ),
  residentClassificationOptions: getRadioOptions(state, 'residentClassificationOptions'),
  nonResidentTaxOptions: getRadioOptions(state, 'nonResidentTaxOptions')
});

export default connect(mapStateToProps)(TaxCalculationSection);
